import { Checkbox, Input, Select } from 'antd';
import classNames from 'classnames';
import { useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { FAIcon } from '../../components/adapters/fontAwesomeAdapters';
import { useSelectsStyles } from '../../components/forms/selects.styles';
import { useMonitorSearchFiltersStyles } from './MonitorSearchFilters.styles';

export function AdvancedFilterMultiSelect({
  value,
  onChange,
  options,
  className,
  ...rest
}) {
  const intl = useIntl();
  const { styles } = useSelectsStyles();
  const { styles: filterStyles } = useMonitorSearchFiltersStyles();
  const selected = value || [];
  const [search, setSearch] = useState();
  const searchRef = useRef();

  const filteredOptions = useMemo(() => {
    const q = search?.trim()?.toLowerCase();
    if (!q) return options;
    return options.filter(o => o.label?.toLowerCase()?.includes(q));
  }, [options, search]);

  return (
    <Select
      {...rest}
      className={classNames(
        'StatusMultiSelect',
        filterStyles.statusMultiSelect,
        className
      )}
      mode="multiple"
      allowClear
      suffixIcon={<FAIcon icon="caret-down" className={styles.selectArrow} />}
      value={selected}
      onChange={onChange}
      options={filteredOptions}
      menuItemSelectedIcon={null}
      maxTagCount={0}
      maxTagPlaceholder={omittedValues => {
        if (!omittedValues.length) {
          return intl.formatMessage({ id: 'filters.labels.status' });
        }
        if (omittedValues.length === 1) {
          return omittedValues[0].label;
        }
        return intl.formatMessage(
          { id: 'filters.labels.status.selected' },
          { count: omittedValues.length }
        );
      }}
      tagRender={({ label }) => (
        <span
          className={classNames(
            'StatusMultiSelect--Summary',
            filterStyles.statusMultiSelectSummary
          )}
        >
          {label}
        </span>
      )}
      popupRender={menu => (
        <>
          <div className={filterStyles.statusSearch}>
            <Input
              ref={searchRef}
              size="small"
              allowClear
              prefix={<FAIcon icon="search" className={styles.searchIcon} />}
              placeholder={intl.formatMessage({ id: 'filters.labels.search' })}
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
          {menu}
        </>
      )}
      optionRender={({ value: optionValue, label }) => (
        <span
          className={classNames(
            'StatusCheckboxList--Item',
            filterStyles.statusCheckboxListItem
          )}
        >
          <Checkbox checked={selected.includes(optionValue)} />
          <span
            className={classNames(
              'StatusCheckboxList--Label',
              filterStyles.statusCheckboxListLabel
            )}
          >
            {label}
          </span>
        </span>
      )}
      onOpenChange={open => {
        if (open) {
          setTimeout(() => searchRef.current?.focus(), 0);
        } else {
          setSearch('');
        }
      }}
    />
  );
}
